import qs from "qs"

import {
  Response,
  YotpoClient,
  YotpoConfig,
  YotpoCreateProductReview,
  YotpoGetProductReviewsQueryParams,
  YotpoResponse,
} from "./types"

export const createYotpoClient = ({ apiKey }: YotpoConfig): YotpoClient => {
  const baseURL = "https://api.yotpo.com"
  const headers = {
    accept: "application/json",
    "Content-Type": "application/json",
  }

  return {
    async createProductReview(review: YotpoCreateProductReview): Promise<any> {
      const res = await fetch(`${baseURL}/reviews/dynamic_create`, {
        body: JSON.stringify({
          appkey: apiKey,
          domain: process.env.GATSBY_SHOPIFY_SHOP_DOMAIN,
          ...review,
        }),
        headers,
        method: "post",
      })

      if (!res.ok) {
        throw new Error(await res.text())
      }

      const json: any = await res.json()

      if (json.status.code !== 200) {
        throw new Error(json.message)
      }

      return json
    },
    async getProductReviews(
      productId: string,
      params?: YotpoGetProductReviewsQueryParams
    ): Promise<YotpoResponse> {
      const res = await fetch(
        `${baseURL}/v1/widget/${apiKey}/products/${productId}/reviews.json?${qs.stringify(
          params
        )}`,
        { headers }
      )

      if (!res.ok) {
        throw new Error(await res.text())
      }

      const json: Response<YotpoResponse> = await res.json()

      if (json.status.code !== 200) {
        throw new Error(json.status.message)
      }

      return json.response
    },
  }
}
